import { Icon } from "@mui/material";
import { CSSProperties, FC, ReactNode } from "react";

const TotalsCard: FC<{
  className?: string;
  style?: CSSProperties;
  headerName: string;
  totalVal: string | number;
  isColor?: boolean;
  icon?: ReactNode;
  isValueBold?: boolean;
}> = ({
  className = "",
  style = {},
  headerName = "",
  totalVal = "",
  isColor = false,
  icon,
  isValueBold,
}) => {
  return (
    <>
      <div className={`flex flex-col flex-1 ${className}`} style={style}>
        <div className="flex gap-1 items-center">
          {" "}
          <span className="fs-12 color-sub-text">{headerName}</span>
          {icon && (
            <span className="border rounded-[4px] w-6 h-6 p-1 flex justify-center items-center  bg-light-primary">
              {icon}
            </span>
          )}
        </div>
        <span
          className={`fs-14 ${isColor ? "color-blue" : ""} ${
            isValueBold ? "font-bold" : ""
          }`}
          style={{ fontSize: isValueBold ? "20px" : "" }}
        >
          {totalVal || "---"}
        </span>
      </div>
    </>
  );
};
export default TotalsCard;
